<template>
    <div class="wrapperFooter">
        <div class="container">
            <div class="colLabel">
                Кабинет
            </div>
            <div class="colLogo">
                <img alt="Work Alfa Diesel" :src="'/img/favicon.png'">
            </div>
            <div class="colInfo">
                ERP AlfaDiesel
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterPage',
    data(){
        return {
            isAuthenticated: parseFloat(localStorage.authenticated),
        }
    },
    methods: {
        // showMenuMobile(){ this.mobile.active = true },
        // hideMenuMobile(){ this.mobile.active = false },
    }
}
</script>